import { ActivitySource } from '../registry/activity-source'
import type { ActivitySourceName, RouterSubscribe } from '../types/activity-source'

export class RouteChangeSource extends ActivitySource {
  readonly name: ActivitySourceName = 'route-changes'

  private readonly routerSubscribe: RouterSubscribe
  private unsubscribeRouter: (() => void) | null = null

  constructor(routerSubscribe: RouterSubscribe) {
    super()
    this.routerSubscribe = routerSubscribe
  }

  protected setup(): void {
    let previousPathname: string | null = null

    this.unsubscribeRouter = this.routerSubscribe((state) => {
      if (state.location.pathname !== previousPathname) {
        previousPathname = state.location.pathname
        this.notify()
      }
    })
  }

  protected teardown(): void {
    this.unsubscribeRouter?.()
    this.unsubscribeRouter = null
  }
}
